import React from 'react';

import { ReactComponent as AllGoodIcon } from 'pages/Teachers/ClassroomInsights/assets/all-good-icon.svg';
import { ReactComponent as NeedsReviewIcon } from 'pages/Teachers/ClassroomInsights/assets/error-icon.svg';
import { ReactComponent as LoadingIcon } from 'pages/Teachers/ClassroomInsights/assets/loading-icon.svg';
import {
  GENERAL_CONCEPTUAL_UNDERSTANDING,
  SIGNIFICANT_ERRORS_IN_WORK,
  UNABLE_TO_DIAGNOSE,
  WORK_IS_COMPLETE_AND_CORRECT
} from 'pages/Teachers/Insights/constants';

export const MASTERY_LEVELS = {
  ABOVE_MASTERY: 'Above Mastery',
  AT_MASTERY: 'At Mastery',
  BELOW_MASTERY: 'Below Mastery',
  NEEDS_REVIEW: 'Needs Review',
  LOADING: 'Loading',
  PENDING_UPLOAD: 'Pending Upload'
};

export const MASTERY_LEVEL_TO_LABEL_MAPPER = {
  [WORK_IS_COMPLETE_AND_CORRECT]: MASTERY_LEVELS.ABOVE_MASTERY,
  [GENERAL_CONCEPTUAL_UNDERSTANDING]: MASTERY_LEVELS.AT_MASTERY,
  [SIGNIFICANT_ERRORS_IN_WORK]: MASTERY_LEVELS.BELOW_MASTERY,
  [UNABLE_TO_DIAGNOSE]: MASTERY_LEVELS.NEEDS_REVIEW,
  Loading: MASTERY_LEVELS.LOADING,
  'Needs Review': MASTERY_LEVELS.NEEDS_REVIEW,
  'Need upload': MASTERY_LEVELS.PENDING_UPLOAD
};

export const BACKGROUND_COLOR_MAPPER = {
  [MASTERY_LEVELS.ABOVE_MASTERY]: {
    borderColor: '#a3d7a3',
    backgroundColor: '#e2f6e2',
    color: '#3A7339'
  },
  [MASTERY_LEVELS.AT_MASTERY]: {
    color: '#40437A',
    backgroundColor: '#f0f1ff',
    borderColor: '#C8C7FF'
  },
  [MASTERY_LEVELS.BELOW_MASTERY]: {
    color: '#a16c07',
    backgroundColor: '#fff8ec',
    borderColor: '#F3DAA8'
  },
  [MASTERY_LEVELS.NEEDS_REVIEW]: {
    borderColor: '#c13245',
    backgroundColor: '#ffeff7',
    color: '#6E6E84'
  },
  [MASTERY_LEVELS.PENDING_UPLOAD]: {
    borderColor: '#CCCCD9',
    backgroundColor: '#FBFBFF',
    color: '#6E6E84'
  }
};

export const STATUS_ICON_MAPPER = {
  [MASTERY_LEVELS.ABOVE_MASTERY]: <AllGoodIcon />,
  [MASTERY_LEVELS.AT_MASTERY]: <AllGoodIcon />,
  [MASTERY_LEVELS.BELOW_MASTERY]: <AllGoodIcon />,
  [MASTERY_LEVELS.NEEDS_REVIEW]: <NeedsReviewIcon />,
  [MASTERY_LEVELS.PENDING_UPLOAD]: <LoadingIcon />
};
